import { getFontStyles } from '@ycos/primitives'
import mrpStyles from './../mrpRtl.json'

const preTitle = {
  ...getFontStyles(mrpStyles, { type: 'Heading', name: 'A1' }),
  fontSizeSmall: '14px',
  fontSizeMedium: '16px',
  lineHeightSmall: '22px',
  lineHeightMedium: '24px'
}

const title = {
  ...getFontStyles(mrpStyles, { type: 'Heading', name: 'A1' }),
  fontSizeSmall: '24px',
  fontSizeMedium: '32px',
  lineHeightSmall: '32px',
  lineHeightMedium: '40px',
  widthSmall: '270px',
  widthMedium: '370px'
}

const textStyles = {
  name: '4',
  type: 'Paragraph'
}

export default {
  preTitle,
  title,
  textStyles
}
